import { Locale } from './types'

export const getLanguageCodeFromCode = (code: string): string => {
    return code.slice(0, 2).toLowerCase()
}

export const getFlagCodeFromLocale = (code: string): string => {
    return code.slice(-2)
}

export const isBrowserLocaleAvailable = (
    availableLocales: Locale[],
    browserLang: string
) => {
    return availableLocales.find((item) =>
        item.code.includes(browserLang)
    )
}

export const isStoredLocaleAvailable = (
    availableLocales: Locale[],
    selectedLocale: Locale
) => {
    return availableLocales.find(
        (item) => item.code === selectedLocale.code
    )
}